const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  warn:  (...args: unknown[]) => { if (isDev) console.warn(...args); },
  error: (...args: unknown[]) => { if (isDev) console.error(...args); },
  info:  (...args: unknown[]) => { if (isDev) console.info(...args); },
};
